
jQuery(function( $ ) {
	$(document).ready( function() {
		const openClass = 'is-open';

		/**
		 * Calculate browser scrollbar width
		 */
		function getScrollbarWidth() {
			const outer = document.createElement( 'div' );
			outer.style.visibility = 'hidden';
			outer.style.overflow = 'scroll';
			document.body.appendChild( outer );

			const inner = document.createElement( 'div' );
			outer.appendChild( inner );

			const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
			outer.parentNode.removeChild( outer );

			return scrollbarWidth;
		}

		/**
		 * Open modal with animation
		 */
		function openModal( modalId ) {
			const $modal = $( '#' + modalId );
			const $backdrop = $( '[data-modal-backdrop="' + modalId + '"]' );

			if ( ! $modal.length || ! $backdrop.length ) {
				return;
			}

			// Calculate and set scrollbar width to prevent layout shift
			const scrollbarWidth = getScrollbarWidth();
			document.documentElement.style.setProperty( '--scrollbar-width', scrollbarWidth + 'px' );

			// Add modal-open class to body to prevent scroll and account for scrollbar
			$( document.body ).addClass( 'modal-open' );

			// Add open class to trigger animations
			$backdrop.addClass( openClass );
			$modal.addClass( openClass );

			// Set focus to modal
			$modal.focus();
		}

		/**
		 * Close modal with animation
		 */
		function closeModal( modalId ) {
			const $modal = $( '#' + modalId );
			const $backdrop = $( '[data-modal-backdrop="' + modalId + '"]' );

			if ( ! $modal.length || ! $backdrop.length ) {
				return;
			}

			// Check if there are other open modals
			const $openModals = $( '[data-modal].is-open' );
			const openModalCount = $openModals.length;

			// Remove open class to trigger animations
			$backdrop.removeClass( openClass );
			$modal.removeClass( openClass );

			// Only remove modal-open class if this was the last open modal
			if ( openModalCount <= 1 ) {
				// Reset scrollbar width variable
				document.documentElement.style.setProperty( '--scrollbar-width', '0px' );
				// Restore body scroll
				$( document.body ).removeClass( 'modal-open' );
			}
		}

		/**
		 * Extract modal ID from trigger
		 * Handles both formats: "modal-123" and "#modal-123"
		 */
		function getModalId( trigger ) {
			let modalId = trigger;
			if ( modalId.startsWith( '#' ) ) {
				modalId = modalId.substring( 1 );
			}
			return modalId;
		}

		/**
		 * Handle trigger button clicks
		 * Supports:
		 * - data-modal-trigger="modal-123" (direct modal trigger)
		 * - data-overlay="#modal-123" (from button filter's isModalLink)
		 * - .is-modal-button class (button filter indicator)
		 */
		$(document).on( 'click', '[data-modal-trigger], .is-modal-button', function( e ) {
			e.preventDefault();
			
			// Get modal ID from various possible attributes
			let modalId = $( this ).attr( 'data-modal-trigger' );
			
			if ( ! modalId ) {
				modalId = $( this ).attr( 'data-overlay' );
			}
			
			if ( modalId ) {
				modalId = getModalId( modalId );
				
				// Verify this is actually a modal (has data-modal attribute)
				// If it's a panel (has data-overlay-panel), skip it
				if ( $( '#' + modalId + '[data-modal]' ).length > 0 ) {
					openModal( modalId );
				}
			}
		} );

		/**
		 * Handle close button clicks
		 */
		$(document).on( 'click', '[data-modal-close]', function( e ) {
			e.preventDefault();
			const modalId = $( this ).attr( 'data-modal-close' );
			closeModal( modalId );
		} );

		/**
		 * Handle backdrop clicks (close modal)
		 */
		$(document).on( 'click', '.wp-block-jormi-modal__backdrop.is-open', function( e ) {
			const modalId = $( this ).attr( 'data-modal-backdrop' );
			closeModal( modalId );
		} );

		/**
		 * Handle Escape key
		 */
		$(document).on( 'keydown', function( e ) {
			if ( e.key === 'Escape' || e.keyCode === 27 ) {
				const $openModals = $( '[data-modal].is-open' );
				$openModals.each( function() {
					const modalId = $( this ).attr( 'id' );
					closeModal( modalId );
				} );
			}
		} );
	} );
});